"use client";
import Image from "next/image";

import { useEffect } from "react";

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error("Global App Error:", error);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [error]);

  return (
    <section className="w-full mainTopPadding">
      <div className="h-700 absolute z-0 inset-x-0 top-15 pointer-events-none bg-[linear-gradient(180deg,var(--primary)_0%,rgba(26,81,170,0)_100%)] before:content-[''] before:absolute before:inset-x-0 before:-top-15.5 before:block before:h-15.5 before:w-full before:bg-(--primary)" />

      <div className="relative text-center mx-auto py-24 px-3 sm:px-0">
        <Image
          src="/next_assets/images/global-error-page.svg"
          alt="Not Found"
          width={400}
          height={285}
          className="w-77.5 sm:w-400 object-contain mb-14 sm:mb-24 mx-auto"
        />
        <p className="text-2.5xl sm:text-4xl leading-1.3! text-(--primary) font-semibold mb-1.5 sm:mb-2.5">
          Something went wrong
        </p>
        <p className="sm:text-xl leading-1.3! font-medium text-black/60 mb-7">Please Try Again or Contact to Support</p>

        <div className="flex items-center justify-center gap-3">
          <button
            onClick={() => reset()}
            className="py-2 xs:py-2.5 w-full max-w-64 rounded-xl text-white border-2 border-(--primary) text-sm sm:text-base font-semibold bg-(--primary) shine-button-hover"
          >
            Try Again
          </button>

          <a
            href="tel:+91-9660032889"
            className="py-2 xs:py-2.5 w-full max-w-64 rounded-xl text-(--primary) border-2 border-[rgb(var(--primary-alpha)/0.6)] text-sm sm:text-base font-semibold bg-white transition hover:bg-[#1f52a71a]"
          >
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}
